import "./Methods.css";

export const formatFilterResponse = (filterResponse) => {
    if (!filterResponse) return "";
  
    const { selectedLanguages, selectedGenre, hdOrSd } = filterResponse;
  
    return (
      <div className="filter-container">
        {selectedLanguages?.length > 0 && (
          <div className="filter-section">
            <h3 className="filter-title">Selected Languages</h3>
            <ul className="filter-list">
              {selectedLanguages.map((lang, index) => (
                <li key={index} className="filter-item">{lang}</li>
              ))}
            </ul>
          </div>
        )}
  
        {selectedGenre?.length > 0 && (
          <div className="filter-section">
            <h3 className="filter-title">Selected Genres</h3>
            <ul className="filter-list">
              {selectedGenre.map((genre, index) => (
                <li key={index} className="filter-item">{genre}</li>
              ))}
            </ul>
          </div>
        )}
  
        {hdOrSd && (
          <div className="filter-section">
            <h3 className="filter-title">Video Quality</h3>
            <p className="filter-item">{hdOrSd.selectedHd ? "HD" : "SD"}</p>
          </div>
        )}
      </div>
    );
  };
  

  export const ChannelPackDisplay = (data) => {
    if (!data) return null;
  
    // Normalize keys from both possible formats
    const channelName = data.channelName || data.addChannelName || [];
    const packName = data.packName || data.addPackName || [];
    const dropChannelName = data.dropChannelName || [];
    const dropPackName = data.dropPackName || [];
    // "{"addChannelName":["Zee Telugu","Zee TV HD","Zee Sarthak"],"addPackName":["Zee5 Starter"],"dropChannelName":["Zee Zest"],"dropPackName":[]}"
    return (
      <div className="filter-container">
        {channelName.length > 0 && (
          <div className="filter-section">
            <h3 className="filter-title">Selected Channels:</h3>
            <ul className="filter-list">
              {channelName.map((channel, index) => (
                <li key={index} className="filter-item">{channel}</li>
              ))}
            </ul>
          </div>
        )}
  
        <div className="filter-section">
          <h3 className="filter-title">Selected Packs:</h3>
          {packName.length > 0 ? (
            <ul className="filter-list">
              {packName.map((pack, index) => (
                <li key={index} className="filter-item">{pack}</li>
              ))}
            </ul>
          ) : (
            <p className="filter-item">No packs selected</p>
          )}
        </div>
        {dropChannelName.length > 0 && (
          <div className="filter-section">
            <h3 className="filter-title">Drop Channels:</h3>
            <ul className="filter-list">
              {dropChannelName.map((channel, index) => (
                <li key={index} className="filter-item">{channel}</li>
              ))}
            </ul>
          </div>
        )}
        {dropPackName.length > 0 && (
          <div className="filter-section">
            <h3 className="filter-title">Drop Packs:</h3>
            <ul className="filter-list">
              {dropPackName.map((channel, index) => (
                <li key={index} className="filter-item">{channel}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };
  
  

  

  export   const handledButtonsUI = () =>{

    let n = document.getElementsByClassName("action-tab");

    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.cursor = "not-allowed";
      // n[i].style.opacity = 0.5;
      n[i].style.pointerEvents = "none";
    }

    let ob = document.getElementsByClassName("option-button")

    for (let i = 0; i < ob.length; i++) {
      ob[i].disabled = true;
      ob[i].style.cursor = "not-allowed";
      // n[i].style.opacity = 0.5;
      ob[i].style.pointerEvents = "none";
    }

    let button = document.getElementsByClassName("a1-wrap");

    for (let i = 0; i < button?.length; i++) {
      button[i].style.cursor = "not-allowed"; 
      // Optional styles if needed:
      // button[i].style.pointerEvents = "none";
    }

    let inputs = document.getElementsByClassName("form-control");

    for (let i = 0; i < inputs?.length; i++) {
      inputs[i].style.cursor = "not-allowed"; // Set cursor style
      inputs[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      // elements[i].style.opacity = "0.5";
      // elements[i].style.pointerEvents = "none";
    }

    let regenerate = document.getElementsByClassName("regenerate");

    for (let i = 0; i < regenerate?.length; i++) {
      regenerate[i].style.cursor = "not-allowed"; // Set cursor style
      regenerate[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      regenerate[i].style.opacity = "0.5";
      regenerate[i].style.pointerEvents = "none";
    }
    let thums = document.getElementsByClassName("thums-button");

    for (let i = 0; i < thums?.length; i++) {
      thums[i].style.cursor = "not-allowed"; // Set cursor style
      thums[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      thums[i].style.opacity = "0.5";
       thums[i].style.pointerEvents = "none";
    }


// Disable DatePicker custom input button
const datePickerBtn = document.getElementsByClassName("custom-datepicker-button");
for (let i = 0; i < datePickerBtn.length; i++) {
  datePickerBtn[i].disabled = true;
  datePickerBtn[i].style.cursor = "not-allowed";
  datePickerBtn[i].style.pointerEvents = "none";
  datePickerBtn[i].style.opacity = 0.5;
}

// Disable hour slider
const hourSlider = document.getElementsByClassName("custom-hour-slider");
for (let i = 0; i < hourSlider.length; i++) {
  hourSlider[i].style.pointerEvents = "none";
  hourSlider[i].style.opacity = 0.5;
  hourSlider[i].style.cursor = "not-allowed";
}

// Disable minute slider
const minuteSlider = document.getElementsByClassName("custom-minute-slider");
for (let i = 0; i < minuteSlider.length; i++) {
  minuteSlider[i].style.pointerEvents = "none";
  minuteSlider[i].style.opacity = 0.5;
  minuteSlider[i].style.cursor = "not-allowed";
}
    
   
    
  }

  export const getFormattedTimestamp = () => {
    return new Date().toLocaleString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).replace(" at ", ", ");
  };
  